import { render, staticRenderFns } from "./biddingConfirm.vue?vue&type=template&id=7695f1c4"
import script from "./biddingConfirm.vue?vue&type=script&lang=js"
export * from "./biddingConfirm.vue?vue&type=script&lang=js"
import style0 from "./biddingConfirm.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports